// ** Custom Components
import Block from "components/layout/Block";

// ** SVG Static Imports
import { ReactComponent as SolidTh } from "resources/icons/solid/th-solid.svg";
import { ReactComponent as SolidList } from "resources/icons/solid/list-solid.svg";
import { LISTING_TYPE } from "helpers/constants";
import { StyledDropdownButtonIcon } from "./DropdownButtonIcon.styled";
import { StyledDropdownContainer } from "./DropdownContainer.styled";

// #####################################################

const ListingTypeSelectorContent = ({
	close,
	selectedViewType,
	setViewType,
}) => {
	// #####################################################

	return (
		<Block flex column justifyBetween fullHeight>
			{/* Menu Główne */}
			<StyledDropdownContainer py={3} px={4}>
				{selectedViewType === LISTING_TYPE.GRID ? (
					<StyledDropdownButtonIcon
						type="fas"
						svgIconComponent={SolidList}
						icon="list-solid"
						onClick={() => {
							setViewType(LISTING_TYPE.LIST);
							close();
						}}
					/>
				) : (
					<StyledDropdownButtonIcon
						type="fas"
						svgIconComponent={SolidTh}
						icon="th-solid"
						onClick={() => {
							setViewType(LISTING_TYPE.GRID);
							close();
						}}
					/>
				)}
			</StyledDropdownContainer>
		</Block>
	);
};

// #####################################################

export default ListingTypeSelectorContent;

// #####################################################
